import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Videos from "@/pages/Videos";
import RoutesPage from "@/pages/Routes";
import RouteDetail from "@/pages/RouteDetail";
import VideoDetail from "@/pages/VideoDetail";
import Patreon from "@/pages/Patreon";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Compliance from "@/pages/Compliance";
import DMCA from "@/pages/DMCA";
import PublicProfile from "@/pages/PublicProfile";
import Members from "@/pages/Members";
import Leaderboards from "@/pages/Leaderboards";
import Trending from "@/pages/Trending";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import AdminBanners from "@/pages/AdminBanners";
import Stats from "@/pages/Stats";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/videos/:id" element={<VideoDetail />} />
        <Route path="/routes" element={<RoutesPage />} />
        <Route path="/routes/:id" element={<RouteDetail />} />
        <Route path="/patreon" element={<Patreon />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/banners" element={<AdminBanners />} />
        <Route path="/admin/stats" element={<Stats />} />
        <Route path="/2257" element={<Compliance />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route path="/dmca" element={<DMCA />} />
        <Route path="/users/:id" element={<PublicProfile />} />
        <Route path="/members" element={<Members />} />
        <Route path="/leaderboards" element={<Leaderboards />} />
        <Route path="/trending" element={<Trending />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster theme="dark" position="top-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
